import * as FilePond from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import {renderPreviewTable} from "./table.ts";
import Handsontable from "handsontable";

// Register plugins
FilePond.registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

// Inicializácia
export function initFileImportUpload(selector: string = '#lunch-menu-import-uploader') {
    const element = document.querySelector(selector) as HTMLInputElement;
    if (!element) return;

    FilePond.setOptions({
        labelFileTypeNotAllowed: 'Súbor nemá povolený typ',
        fileValidateTypeLabelExpectedTypes: 'Očakávané: {allTypes}',
        labelIdle: 'Sem presuň, alebo <span class="filepond--label-action">vyber</span> súbor MS Excel',
        labelInvalidField: 'Pole obsahuje neplatné súbory',
        labelFileWaitingForSize: 'Čakám na veľkosť',
        labelFileSizeNotAvailable: 'Veľkosť nedostupná',
        labelFileLoading: 'Nahrávam',
        labelFileLoadError: 'Chyba pri nahrávaní',
        labelFileProcessing: 'Nahrávam',
        labelFileProcessingComplete: 'Hotovo',
        labelFileProcessingAborted: 'Nahrávanie zrušené',
        labelFileProcessingError: 'Chyba pri nahrávaní',
        labelFileProcessingRevertError: 'Nepodarilo sa vrátiť späť',
        labelFileRemoveError: 'Nepodarilo sa odstrániť',
        labelTapToCancel: 'Klikni pre zrušenie',
        labelTapToRetry: 'Klikni pre opakovanie',
        labelTapToUndo: 'Klikni pre späť',
        labelButtonRemoveItem: 'Odstrániť',
        labelButtonAbortItemLoad: 'Zrušiť',
        labelButtonRetryItemLoad: 'Skúsiť znova',
        labelButtonAbortItemProcessing: 'Zrušiť',
        labelButtonUndoItemProcessing: 'Späť',
        labelButtonRetryItemProcessing: 'Skúsiť znova',
        labelButtonProcessItem: 'Nahrať',
    });

    // @ts-ignore
    FilePond.create(element, {
        acceptedFileTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel'
        ],
        maxFileSize: '5MB',
        maxFiles: 1,
        maxParallelUploads: 1,
        server: {
            process: {
                url: '/lunch/import/preview',
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content,
                },
                onload: (response: string): string | number => {
                    const parsed = JSON.parse(response);
                    console.log('📥 Náhľad importu:', parsed);
                    const previewData = parsed.preview || [];

                    if (typeof window !== 'undefined') {
                        window.importTable = renderPreviewTable('import-preview-table', previewData);
                        if (window.importTable instanceof Handsontable) {
                            // Bezpečne deaktivuje plugin aj ak bol zapnutý cez iné pluginy
                            window.importTable.getPlugin('dropdownMenu')?.disablePlugin?.();
                            window.importTable.updateSettings({ dropdownMenu: false });
                        }
                    }

                    return '';
                },
                onerror: (err: any) => {
                    console.error('❌ Upload error:', err);
                }
            }
        },

        // ✅ sem patrí správne onremovefile
        onremovefile: (file) => {
            console.log('🗑️ Súbor odstránený:', file);

            // Vyčisti Handsontable
            if (window.importTable) {
                window.importTable.loadData([]);
            }
        }
    });
}

export function initActionImportLunchMeals(selector: string = '#action_import_lunch_meals') {

    console.log('initActionImportLunchMeals');

    const importButton = document.querySelector(selector) as HTMLInputElement;
    if (!importButton) return;

    // @ts-ignore
    const popover = new bootstrap.Popover(importButton, {
        trigger: 'manual', // ovládame ručne
        html: true
    });
    console.log(popover);

    importButton.addEventListener('click', (e) => {
        e.preventDefault();
        uploadChunks().then(r => {
            // @ts-ignore
            window.importTable.loadData([]);

            const input = document.querySelector('#lunch-menu-import-uploader'); // tvoj input
            console.log(input);
            if (input) {
                const pond = FilePond.find(input);
                pond.removeFiles();
            }

            showSuccess(); // hotovo!
        })
    })
}

async function uploadChunks() {
    let data;
    let chunkSize = 20;
    let processed = 0;

    // @ts-ignore
    data = window.importTable.getData(); // všetky dáta
    console.log('data', data);
    console.log('chunkSize', chunkSize);
    console.log('processed', processed);

    let total = data.length; console.log('total', total);

    if (total === 0) {
        return;
    }

    for (let i = 0; i < data.length; i += chunkSize) {
        const chunk = data.slice(i, i + chunkSize);
        const csrfTokenElement = document.querySelector('meta[name="csrf-token"]');
        const csrfToken: string | undefined = csrfTokenElement?.getAttribute('content') || undefined;

        const formData = new URLSearchParams();
        formData.append('chunk', JSON.stringify(chunk));
        formData.append('restaurant_id', localStorage.getItem('restaurant_id') || '');
        console.log('calling: /lunch/import/data with chunk: ', chunk, ' and csrfToken: ', csrfToken || 'undefined')
        await fetch('/lunch/import/data', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-CSRF-TOKEN': csrfToken || '',
            },
            body: formData.toString(),
        });

        processed += chunk.length;
        const percent = Math.round((processed / total) * 100);
        updateProgressBar(percent); // tvoja vlastná funkcia
    }
}

function updateProgressBar(percent: number) {
    const bar = document.getElementById('upload-progress-bar');
    if (bar) {
        bar.style.width = `${percent}%`;
        bar.textContent = `${percent}%`;
    }
}

function showSuccess() {
    // @ts-ignore
    Snackbar.show({
        pos: 'top-center',
        text: "Import jedál bol úspešne dokončený",
        backgroundColor: "#4BB84D"
    });
}